import { ProgramCategoryFilterRow } from 'components/eventView/filters/ProgramCategoryFilterRow';
import { ProgramDayFilterRow } from 'components/eventView/filters/ProgramDayFilterRow';
import { EventViewProgramPageContent } from 'components/eventView/pages/EVProgramPageContent';
import { SplitTitle } from 'components/guide/split/SplitTitle';
import { SearchInput } from 'elements/eventView/atomic/SearchInput';
import { EVPcScrollAnchors } from 'pages/EventViewPage/EventViewPagePC/eVScrollAnchors';
import { useContext } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const EVProgramPagePC = (props: Props) => {
    const ctxEventView = useContext(CtxEventView);
    const { visiblePrograms, programSearchTerm, setProgramSearchTerm } = ctxEventView;

    return (
        <S_EVProgramPagePC className={props.className} id={EVPcScrollAnchors.Program}>
            <S_SplitTitle number={visiblePrograms?.length} title={ctxEventView.programTitleShort} />

            {ctxEventView.eventData.programSettings?.searchable && (
                <S_SearchInput
                    value={programSearchTerm}
                    onChange={(value) => {
                        setProgramSearchTerm(value);
                    }}
                    clearButton
                />
            )}
            <S_ProgramDayFilterRow />
            <ProgramCategoryFilterRow isWide={true} />
            <S_EVProgramPageContent />
        </S_EVProgramPagePC>
    );
};

const S_EVProgramPagePC = styled.div`
    position: relative;
`;

const S_SplitTitle = styled(SplitTitle)`
    margin: 60px 0 60px 0;
`;

const S_EVProgramPageContent = styled(EventViewProgramPageContent)`
    width: 700px;
    max-width: 100%;
    margin: 0 auto;
`;

const S_ProgramDayFilterRow = styled(ProgramDayFilterRow)``;

const S_SearchInput = styled(SearchInput)`
    position: absolute;
    width: 300px;
    right: 0;
    top: -5px;
`;
